var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.875C20.433 16.875 22 13.9649 22 10.375C22 6.78515 20.433 3.875 18.5 3.875M18.5 16.875C16.567 16.875 15 13.9649 15 10.375C15 6.78515 16.567 3.875 18.5 3.875M18.5 16.875L5.44354 14.5011C4.51605 14.3325 4.05231 14.2481 3.67733 14.064C2.91447 13.6892 2.34636 13.0085 2.11414 12.1909C2 11.789 2 11.3177 2 10.375C2 9.4323 2 8.96095 2.11414 8.55907C2.34636 7.74149 2.91447 7.06077 3.67733 6.68605C4.05231 6.50185 4.51605 6.41754 5.44354 6.2489L18.5 3.875M5 14.875L5.39386 20.389C5.43126 20.9126 5.44996 21.1745 5.56387 21.3729C5.66417 21.5476 5.81489 21.6879 5.99629 21.7755C6.20232 21.875 6.46481 21.875 6.98979 21.875H8.7722C9.37234 21.875 9.67242 21.875 9.89451 21.7553C10.0897 21.6501 10.2443 21.4831 10.3342 21.2805C10.4365 21.0499 10.4135 20.7507 10.3675 20.1523L10 15.375",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.ba9dbfba0072ffac2744e803d6f4b57d.svg";
export { ForwardRef as ReactComponent };